import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',
    'resource:data.dimensions.projects.entities.project.attributes.organization',
    'resource:data.dimensions.projects.entities.project.attributes.sponsor',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.department',
    'resource:data.dimensions.organization.entities.division',
    'resource:data.dimensions.sponsors',
    'resource:data.dimensions.sponsors.entities.sponsor',
    'resource:data.dimensions.space',
    'resource:data.dimensions.space.attributes.sqft',
    'resource:data.dimensions.space.entities.campus',
    'resource:data.dimensions.space.entities.building',
    'resource:data.dimensions.space.entities.floor',
    'resource:data.dimensions.space.entities.room',
    'resource:data.dimensions.space.entities.room.attributes.hegisCode',
    'resource:data.dimensions.space.entities.room.attributes.spaceUse',
    'resource:data.dimensions.spaceUse',
    'resource:data.dimensions.spaceUse.entities.roomType',
    'resource:data.dimensions.spaceFunctions',
    'resource:data.dimensions.spaceFunctions.entities.function',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.idcFunction',
    'resource:data.dimensions.glAccounts',
    'resource:data.dimensions.glAccounts.entities.account',
    'resource:data.dimensions.glAccounts.entities.account.attributes.isInMtdc',
    'resource:data.dimensions.glAccounts.entities.account.attributes.costType',
    'resource:data.dimensions.spaceFunctionalization',
    'resource:data.dimensions.spaceFunctionalization.entities.entry',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.space',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.organizationSpace',
    'resource:data.dimensions.organizationSpace.entities.entry',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.organization',
    'resource:data.dimensions.organizationSpace.entities.entry.attributes.space',
    'resource:data.dimensions.personnelSpace',
    'resource:data.dimensions.personnelSpace.entities.entry',
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.space',
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.personnel',
    'resource:data.dimensions.projectPis',
    'resource:data.dimensions.projectPis.entities.entry',
    'resource:data.dimensions.projectPis.entities.entry.attributes.pi',
    'resource:data.dimensions.projectPis.entities.entry.attributes.project',
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.dimensions.idcFunctions',
    'resource:data.dimensions.idcFunctions.entities.category',
    'resource:data.dimensions.idcFunctions.attributes.position',
    'resource:data.dimensions.glExpenses',
    'resource:data.dimensions.glExpenses.entities.entry',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.account',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.organization',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.project',
    'resource:solutions.apps.rpNymc.pages.explore',
    'resource:solutions.apps.rpNymc.pages.overview',
    'resource:solutions.apps.rpNymc.pages.trends',
    'resource:solutions.apps.rpNymc',
    'resource:solutions.mosaic.pages.rpNymc.explore',
    'resource:solutions.mosaic.pages.rpNymc.overviewWithPiScatter',
    'resource:solutions.mosaic.pages.rpNymc.trends',
    'resource:solutions.mosaic.widgets.rpNymc.deptScatter',
    'resource:solutions.mosaic.widgets.rpNymc.piScatter',
    'resource:solutions.mosaic.widgets.rpNymc.exploreMetrics',
    'resource:solutions.mosaic.widgets.rpNymc.explorePerfComparison',
    'resource:solutions.mosaic.widgets.rpNymc.exploreTrends',
    'resource:solutions.mosaic.widgets.rpNymc.orgTable',
    'resource:solutions.mosaic.widgets.rpNymc.overviewDonut',
    'resource:solutions.mosaic.widgets.rpNymc.overviewMetrics',
    'resource:solutions.mosaic.widgets.rpNymc.overviewTrends',
    'resource:solutions.mosaic.widgets.rpNymc.piTable',
    'resource:solutions.mosaic.widgets.rpNymc.projectsTable',
    'resource:solutions.mosaic.widgets.rpNymc.spaceTable',
    'resource:solutions.mosaic.widgets.rpNymc.sponsorsTable',
    'resource:solutions.mosaic.widgets.rpNymc.trendsStacked',
    'resource:solutions.mosaic.widgets.rpNymc.trendsTable',
  ],
  description: 'Standard Research Performance',
  name: 'RP',
} as const satisfies core.quiver.Package
